import { FC } from "react";
import { IconProps } from "./types";

export const SocialLinkedinFilled: FC<IconProps> = ({
  fill = "#000",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zM6.269 7.8c0-.725.55-1.278 1.388-1.278.842 0 1.359.553 1.375 1.279 0 .708-.533 1.277-1.39 1.277h-.017c-.823 0-1.356-.57-1.356-1.277zm6.418 3.333c.328-.504.912-1.22 2.215-1.22 1.617 0 2.83 1.056 2.83 3.327v4.237h-2.458v-3.954c0-.993-.355-1.672-1.245-1.672-.401 0-.707.16-.927.384a1.591 1.591 0 0 0-.334.516c-.065.158-.08.377-.08.599v4.127H10.23s.01-1.875.013-3.745c.003-1.662.002-3.319-.013-3.645h2.457v1.046zm-6.274 6.346h2.458v-7.392H6.413v7.392z"
      fill={fill}
    />
  </svg>
);
